import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_automotive-boost-3/artifacts/7jp7f6b1_LOGO-CARWAYS-FONDO-NEGRO.jpg";
const META = "https://customer-assets-v7afamib.emergentagent.net/job_automotive-boost-3/artifacts/lheqedva_image.png";

const STATS = [
  { n: "56", l: "Leads interesados en importación" },
  { n: "2,05€", l: "Coste por lead" },
  { n: "5", l: "Coches vendidos en importación" },
  { n: "114,68€", l: "Invertidos en campaña" },
];

export default function CasoCarways() {
  return (
    <section id="caso-carways" data-testid="caso-carways-section" className="relative py-24 lg:py-32 border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(90% 70% at 30% 0%, rgba(0,160,160,.07), transparent 55%)" }} />
      <div className="max-w-5xl mx-auto px-4 md:px-8 relative">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="font-stencil text-xs text-[#00A0A0] tracking-widest">CASO REAL</span>
            <img src={LOGO} alt="Carways Mobility" className="h-9 w-auto object-contain" data-testid="carways-logo" />
          </div>
          <h2 className="font-heading text-white text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight leading-[0.95]">
            Compraron un coche sin verlo.
            <br />
            <span className="font-stencil text-[#00A0A0]">Y confiaron.</span>
          </h2>
          <p className="mt-6 text-white/60 max-w-2xl font-body text-base lg:text-lg leading-relaxed">
            En importación, el cliente paga por un coche que no ha visto en persona — compra a ciegas, basándose solo en la confianza que le genera quien se lo vende.
          </p>
        </Reveal>

        {/* Cifras */}
        <Reveal delay={80}>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/[0.06] rounded-2xl overflow-hidden border border-white/10 mt-12">
            {STATS.map((s, i) => (
              <div key={i} className="bg-[#0a0e0d] p-6 lg:p-7" data-testid={`carways-stat-${i}`}>
                <div className="font-heading text-[#00C8C8] text-3xl sm:text-4xl lg:text-5xl leading-none tracking-tight">{s.n}</div>
                <div className="mt-3 text-white/50 font-body text-xs sm:text-sm leading-snug uppercase tracking-wide">{s.l}</div>
              </div>
            ))}
          </div>
        </Reveal>

        {/* Narrativa + cierre */}
        <Reveal delay={120}>
          <div className="mt-12 max-w-3xl">
            <p className="text-white/70 font-body text-base lg:text-lg leading-relaxed">
              Con <strong className="text-white">114,68€</strong> invertidos en captación de importación, Carways Mobility generó <strong className="text-white">56 personas interesadas</strong> en comprar así. <strong className="text-[#00A0A0]">Cinco de ellas compraron.</strong>
            </p>
            <p className="mt-8 font-heading text-white text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight leading-tight">
              Así de fuerte tiene que ser la confianza
              <br className="hidden sm:block" />
              <span className="text-[#FFD700]"> cuando no hay coche delante.</span>
            </p>
          </div>
        </Reveal>

        {/* Prueba: captura Meta Ads en marco de navegador */}
        <Reveal delay={160}>
          <div className="mt-14 rounded-xl overflow-hidden border border-white/10 bg-[#0c100f]" data-testid="carways-proof">
            <div className="flex items-center gap-2 px-4 py-3 border-b border-white/10 bg-black/40">
              <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
              <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
              <span className="w-3 h-3 rounded-full bg-[#28c840]" />
              <span className="ml-3 text-[11px] text-white/35 font-body truncate">Meta Ads Manager · LEADS-IMPORTACION-ESP</span>
            </div>
            <div className="bg-white overflow-x-auto">
              <img src={META} alt="Captura de Meta Ads Manager - campaña LEADS-IMPORTACION-ESP" className="block min-w-[720px] w-full" />
            </div>
          </div>
          <p className="mt-4 text-xs text-white/40 font-body leading-relaxed">
            Sin retocar, tal cual la exporta Meta · campaña <span className="text-white/60">"LEADS-IMPORTACION-ESP"</span> · activa desde el 14 jul. 2026.
          </p>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-14 text-center">
            <a
              href="#contacto"
              data-testid="carways-cta"
              className="h-14 btn-angular bg-[#00A0A0] hover:bg-[#00C8C8] text-black text-xs sm:text-base font-stencil uppercase tracking-widest rounded-none group inline-flex items-center justify-center gap-2 px-8 transition-colors"
              style={{ boxShadow: "5px 5px 0 #FFD700" }}
            >
              RESERVAR LLAMADA
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <p className="mt-4 text-[13px] text-white/45 font-body max-w-xl mx-auto leading-relaxed">
              30 minutos. Sin compromiso. Revisamos tu situación y te decimos con claridad qué mejoraríamos — encajemos o no.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
